import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_discipline } from "../shared/data.service";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./disciplineprint.component.html",
	styleUrls: ["./disciplineprint.component.css"],
	providers: [ConfirmationService],
})
export class DisciplinePrintComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_discipline,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public UserID: number;
	public PersonID: number;
	public IncidentID: number;
	public isAlertsOnly: boolean;
	public StartDate: Date = new Date();
	public EndDate: Date = new Date();

	//	Report Selector
	public lstReportItems: any = [];
	public SelectedReport: any;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.UserID = this.dialogConfig.data.UserID;
		this.IncidentID = this.dialogConfig.data.IncidentID;
		this.PersonID = this.dialogConfig.data.PersonID;
		this.StartDate = this.dialogConfig.data.StartDate;
		this.EndDate = this.dialogConfig.data.EndDate;

		//
		//	Set Report Items
		//
		this.lstReportItems = [
			{ ReportID: 1, ReportDesc: "Regular Discipline" },
			{ ReportID: 2, ReportDesc: "Single Discipline History" },
		];

		this.SelectedReport = this.lstReportItems[0];

		this.isAlertsOnly = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onReportChange
	//
	//-----------------------------------------------------------------------------------------------------
	onReportChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		var result = this.dataService.Print_IncidentReport(
			this.SelectedReport.ReportID,
			this.IncidentID,
			this.PersonID,
			this.isAlertsOnly,
			this.StartDate,
			this.EndDate
		);

		//
		//	Generate PDF
		//
		this.isBusy = true;

		result.subscribe(
			(response: any) => {
				this.isBusy = false;

				if (response == "No Data available") {
					this.ErrorMessage = response;
				} else {
					window.open(response);

					//
					// 0 = CANCEL; 1 = SAVE
					//
					this.ref.close(1);
				}
			},
			(error) => {
				this.isBusy = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
